/**
 * Leads (WP3-LEADS, BUILD-PLAN M14): the lead pipeline board and list, lead
 * detail with the DentChat transcript, and the web chat widget settings.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'leads',
    title: 'Leads',
    version: '0.1.0',
    owner: 'WP3-LEADS',
    entitlementKey: null,
    permissions: ['comms.view', 'comms.send', 'settings.manage', 'money.view'],
    routes: [
      {
        id: 'board',
        path: '/leads',
        title: 'Leads',
        permission: 'comms.view',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Leads',
        group: 'patients',
        routeId: 'board',
        icon: 'user-plus',
        order: 30,
        permission: 'comms.view',
      },
    ],
    commands: [
      {
        id: 'leads.open',
        title: 'Go to Leads',
        keywords: ['leads', 'pipeline', 'prospects', 'dentchat', 'web chat', 'new patients'],
        routeId: 'board',
        permission: 'comms.view',
      },
    ],
    shortcuts: [{ keys: 'g d', description: 'Go to Leads', routeId: 'board' }],
    sseEntityKeys: ['lead'],
    phiReadPoints: ['lead.list', 'lead.open'],
  }),
  pages: {
    board: () => import('./LeadsPage.js'),
  },
});
